/** @param {string} str */
export const toDashCase = str => str.replace(/\s+/g, '-').toLowerCase();

export const sortItemsByTimestamp = items => items.sort((a, b) => b.timestamp - a.timestamp);

export const isObject = obj => typeof obj === 'object';

export const padZero = (val, len) => {
	let res = `${val}`;
	while (res.length < len) {
		res = `0${res}`;
	}
	return res;
};

export const getTimeLabelFromSeconds = value => {
	const minutes = Math.floor(Math.round(value) / 60);
	const seconds = Math.round(value) - minutes * 60;
	return [minutes, seconds].map(val => padZero(val, 2)).join(':');
};

export const capitalizeFirstLetter = string => {
	return string.charAt(0).toUpperCase() + string.slice(1);
};

export const isOverflown = element => {
	return element && (element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth);
};
